import styled from 'styled-components';

import { appendImageCDNToStaticUrl } from '@/shared/utils';

import gradientShape1 from './assets/images/gradient-shape-1.jpg';
import gradientShape2 from './assets/images/gradient-shape-2.jpg';

const shape1Image = appendImageCDNToStaticUrl(gradientShape1.src);
const shape2Image = appendImageCDNToStaticUrl(gradientShape2.src);

export const FreeTrialBannerWrapper = styled.section`
  background-image: url(${shape2Image});
  background-position: 100% 13%;
  background-repeat: no-repeat;
  ${props => props.theme.breakpoints.up('sm')} {
    background-image: url(${shape1Image});
    background-position: -20% 35%;
  }
`;

export const BannerWrapper = styled.div`
  border-radius: 5px;
`;
